import React from "react";

const CommonProgress = ({mobile}) => {
  return (
    <>
      <div style={mobile && {height: "85vh", display: "flex", alignItems: "center"}}>
        <span
          className="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        ></span>
      </div>
    </>
  );
};

export default CommonProgress;
